<template>
<el-card>
    <template v-slot:header>
        <div class="clearfix">
            <span style="font-weight: bold;"><i class="el-icon-pie-chart" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Compartment Proportion</span>
        </div>
    </template>
    <div class="container">
        <div id="compartment" style="width:100%;height:500px;"></div> 
    </div>
</el-card>
</template>

<script>
export default {
    props: {
    species: {
        type: String,
        required: true
    },
    tissue: {
        type: String,
        required: true
    }
    },
    data() {
    return {
        chartData: [],
        url: "http://183.175.59.4/devenhancer/",// 后端接口地址
    };
    },
    mounted() {
    this.handleAnalysis();
    },
    methods: {
    handleAnalysis() {
        // 发送请求获取后端数据
        const params = { Species: this.species, Tissue: this.tissue };
        this.$axios.get(this.url + "compartment" + "/", { params }).then((response) => {
            // 对数据进行处理
            const data = response.data;
            if (data && Array.isArray(data) && data.length > 0) {
                const count = {
                A: 0,
                B: 0
            };
            for (let item of data) {
            let value = '';
            // 获取annotation字段的数据，并将其作为统计变量
            if (item.Value) {
                    value = item.Value.trim();
                    if (Number(value) > 0) {
                        count.A++;
                    } else if (Number(value) < 0) {
                        count.B++;
                    }
                }
            }
            // 将 count 中的数据转换为饼图所需的格式
            const seriesData = [
                {
                    name: 'A compartment',
                    value: count.A,
                    itemStyle: {
                        color: '#B5C99A'
                    }
                },
                {
                    name: 'B compartment',
                    value: count.B,
                    itemStyle: {
                        color: '#FFC95F'
                    }
                }
            ];
            // 绘制饼图
            const chart = this.$echarts.init(document.getElementById('compartment'));
            chart.setOption({
            title: {
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
                right: '10%', // 图例在容器右侧偏移 10%
                orient: 'horizontal', // vertical是垂直布局
                align: 'left', // 左对齐
                itemWidth: 20, // 控制每个图例项的宽度
                itemGap: 10, // 控制每个图例项之间的间距
            },
            series: [
                {
                name: 'Compartment',
                type: 'pie',
                radius: ['20%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    show: true,
                },
                emphasis: {
                    label: {
                    show: true,
                    fontSize: '15',
                    fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: true
                },
                data: seriesData
                }
            ]
            });
            
        } else {
            this.$message.warning('No data found.');
        }
    }).catch(err => {
        console.error(err);
        this.$message.error('Failed to fetch data.');
        });
    },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/compartment/Ab.vue